module.exports = __webpack_public_path__ + "img/ico_header_mypage.0a19d84.svg";